import { Field as ChakraField, Flex, HStack, VStack } from 'chakra-ui-next'
import * as React from 'react'
import { InfoTip } from './toggle-tip'

export interface FieldProps extends Omit<ChakraField.RootProps, 'label'> {
  label?: React.ReactNode
  helperText?: React.ReactNode
  errorText?: React.ReactNode
  optionalText?: React.ReactNode
  justifyContent?: string
  infoText?: React.ReactNode
}

// Vertical Field component
export const VField = React.forwardRef<HTMLDivElement, FieldProps>(function VField(props, ref) {
  const { label, children, helperText, errorText, optionalText, infoText, ...rest } = props

  return (
    <ChakraField.Root ref={ref} {...rest}>
      {label && (
        <ChakraField.Label>
          {label}
          <ChakraField.RequiredIndicator fallback={optionalText} />
          {infoText && <InfoTip>{infoText}</InfoTip>}
        </ChakraField.Label>
      )}
      {children}
      {helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}
      {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  )
})

// Horizontal Field component
export const HField = React.forwardRef<HTMLDivElement, FieldProps>(function HField(props, ref) {
  const {
    label,
    children,
    helperText,
    errorText,
    optionalText,
    justifyContent = 'space-between',
    infoText,
    ...rest
  } = props

  return (
    <ChakraField.Root ref={ref} gap="0" {...rest}>
      <HStack justifyContent={justifyContent} alignItems="center" width="full">
        <VStack gap="-1" w="full" alignItems="flex-start">
          {label && (
            <ChakraField.Label flexShrink={0}>
              {label}
              <ChakraField.RequiredIndicator />
              {infoText && <InfoTip>{infoText}</InfoTip>}
            </ChakraField.Label>
          )}

          {helperText && <ChakraField.HelperText>{helperText}</ChakraField.HelperText>}
        </VStack>
        <Flex w="7/12" justifyContent="flex-end">
          {children}
        </Flex>
      </HStack>
      {errorText && <ChakraField.ErrorText>{errorText}</ChakraField.ErrorText>}
    </ChakraField.Root>
  )
})
export const Field = VField

export const FieldLabel = ChakraField.Label
